const VERSION = '2.4.0';
const BUILD_DATE = '2026-02-27';

export { VERSION, BUILD_DATE };
